import {AllAppsGrid} from "~/components/allAppsGrid";
import {BuiltWithFounders} from "~/components/builtWithFounders";
import {Hero} from "~/components/hero";
import {ProblemStatement} from "~/components/problemStatement";
import {TeamSolutions} from "~/components/teamSolutions";
import {VentureSection} from "~/components/ventureSection";

export default function RouteComponent() {
    return (
        <>
            <Hero />
            <BuiltWithFounders />
            <ProblemStatement />
            <AllAppsGrid />
            <VentureSection />
            <TeamSolutions />
        </>
    );
}
